jQuery(document).foundation();
/* 
These functions make sure WordPress 
and Foundation play nice together.
*/

jQuery(document).ready(function() {
    
    // Remove empty P tags created by WP inside of Accordion and Orbit
    jQuery('.accordion p:empty, .orbit p:empty').remove();
    
	 // Makes sure last grid item floats left
	jQuery('.archive-grid .columns').last().addClass( 'end' );
	
	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').wrap("<div class='flex-video'/>");


	var themeLayout = jQuery('body').attr('data-theme-layout');

	var autoplay = false;
	var slickArrows = false;
	var slickDots = false;
	var autoplaySpeed = 4000;

	var heroSlider = jQuery('.hero-slider');

	if(heroSlider.attr("data-autoplay") && heroSlider.attr("data-autoplay") == 1) {
		autoplay = true;
	}
	if(heroSlider.attr("data-autoplay-speed")) {		
		autoplaySpeed = heroSlider.attr("data-autoplay-speed") * 1000;;
	}
	if(heroSlider.attr("data-arrows") && heroSlider.attr("data-arrows") == 1) {
		slickArrows = true;
	}
	if(heroSlider.attr("data-dots") && heroSlider.attr("data-dots") == 1) {
		slickDots = true;
	}

	jQuery('.hero-slider').slick({
		infinite: false,
		dots: slickDots,
		arrows: slickArrows,
		infinite: true,
		draggable: false,
		autoplay: autoplay,
		autoplaySpeed: autoplaySpeed,
		fade: true
	});
	
	var htmlMarginTop = jQuery('html').css("margin-top");
	var headerHeight = jQuery('.header').height()+"px";
	
	if( jQuery('body').hasClass('sticky-header') && !jQuery('body').hasClass('header-transparent')) {	   
	    jQuery('.off-canvas-content').css({'padding-top': headerHeight });
	    jQuery('.sticky-header .header').css({'top': htmlMarginTop });
	}
	
	jQuery( window ).resize(function() {
	    
	    var headerHeight = jQuery('.header').height()+"px";
	    var htmlMarginTop = jQuery('html').css("margin-top");
        
        if( jQuery('body').hasClass('sticky-header') && !jQuery('body').hasClass('header-transparent')) {    	   
    	    jQuery('.off-canvas-content').css({'padding-top': headerHeight });
    	    jQuery('.sticky-header .header').css({'top': htmlMarginTop });
	    }
	    
	});
	
	jQuery(window).scroll(function (event) {
		if(jQuery(window).width() < 641){
			var hmt = htmlMarginTop.replace("px","");
			var scroll = jQuery(window).scrollTop();
    
			if(scroll > hmt ){
				jQuery('.off-canvas-content .header').css({
					'top': "0"
				});
			} 
			if( scroll <= hmt ){
				jQuery('.off-canvas-content .header').css({
					'top': (hmt - scroll) + "px"
				});
			}
		}        
    });
	

	

	   jQuery('.hero-gallery-slides').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        infinite: true,
        autoplay: true,
        arrows: false,
        asNavFor : '.hero-gallery-slides-thumb',
        fade : true,
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 641,
                settings: {
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: true,
                    dots: false,
                    arrows: false,
                    speed: 400,
                    autoplaySpeed: 6000,
                    asNavFor : '.hero-gallery-slides-thumb',
                }
            },
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    asNavFor : '.hero-gallery-slides-thumb',
                }
            }
    
         ]


    });

    jQuery('.hero-gallery-slides-thumb').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: false,
        asNavFor : '.hero-gallery-slides',
        centerMode : false,
        focusOnSelect: true
    });


	
	function generate_carousel( elem, param, asnavfor="" ) {
	    
	    var sm = 1, md = 1, lg = 1;
	    var parent_section = elem.closest('.page-element');
    	var showDots = parent_section.hasClass('show-slider-dots') ? true : false;
    	var showArrows = parent_section.hasClass('hide-slider-arrows') ? false : true;
    	var non_slider_on_large = parent_section.hasClass('disable-carousel-large');
    	var cm = parent_section.hasClass('carousel-center-mode') ? true : false;
	    var autoplay = false;
	    var cp = '25%';

	    var unslickonlarge = false;
	    if(non_slider_on_large) unslickonlarge = true;

	    var autoplaySpeed = 6000;

	    var autoplayAttr = elem.attr('data-autoplay');

	    if(typeof autoplayAttr !== typeof undefined && autoplayAttr == 1) {
	    	var autoplay = true;
	    }

	    if(elem.attr("data-autoplay-speed")) {		
			autoplaySpeed = elem.attr("data-autoplay-speed") * 1000;
		}

	  
        switch( param ) {
            case 'medium-6':
                md = cm ? 1 : 2;
                lg = cm ? 1 : 2;
            break;
            
            case 'medium-4':
                md = cm ? 1 : 2;
                lg = cm ? 1 : 3;
            break;    

            case 'medium-6 large-4':
				md = cm ? 1 : 2;
                lg = cm ? 1 : 3;
            break;               	
            
            case 'medium-6 large-3':
                md = cm ? 1 : 2;
                lg = cm ? 1 : 4;
            break;
            
            case 'medium-4 large-2_4':
                md = cm ? 1 : 2;
                lg = cm ? 3 : 5;
                cp = '15%';
            break;

            case 'medium-4 large-2':
                md = cm ? 1 : 2;
                lg = cm ? 3 : 6;
                cp = '15%';
            break;
        }
        
        
        if(elem.data('element') == 'testimonials') {
            
             elem.slick({
        		dots: showDots,
        		arrows: showArrows,
        		infinite: true,
        		draggable: cm ? true : false,
        		autoplay: autoplay,
        		slidesToShow: lg,
        		slidesToScroll: 1,
        		autoplaySpeed: autoplaySpeed,
        		centerMode: cm,
        		centerPadding: cm ? cp : '',
        		asNavFor: asnavfor,
        			responsive:[
        		 		{
        		 			breakpoint: 641, 
        		 				settings: {
        			        		 infinite: true,
        			        		 slidesToShow: sm,
        			        		 slidesToScroll: 1,
        			        		 autoplay: autoplay, 
        			        		 dots: showDots,
        			        		 arrows: showArrows,
        			        		 speed: 400,
        			        		 autoplaySpeed: autoplaySpeed,
        			        		 centerMode: cm,
    								 centerPadding: cm ? '25%' : '',
    								 asNavFor: asnavfor,
        		 				}
        		 		},
        		 		{
        		 			breakpoint: 1024, 
        		 				settings: {
        			        		infinite: true,
        			        		slidesToShow: md,
        			        		slidesToScroll: 1,
        			        		autoplay: autoplay, 
        			        		arrows: showArrows,
        			        		dots: showDots,
        			        		speed: 400,
        			        		autoplaySpeed: autoplaySpeed,
        			        		centerMode: cm,
    								centerPadding: cm ? '25%' : '',
    								asNavFor: asnavfor,
        		 				}
        		 		},
				 		{
				 		    breakpoint: 9999,
				 			settings: unslickonlarge ? "unslick" : {}
					 	}
        		 	]
        	    });
            
        } else {
            
        
	    
	    elem.slick({
		dots: showDots,
		arrows: showArrows,
		infinite: true,
		draggable: cm ? true : false,
		autoplay: autoplay,
		slidesToShow: lg,
		slidesToScroll: 1,
		autoplaySpeed: autoplaySpeed,
		centerMode: cm,
		centerPadding: cm ? cp : '',
		asNavFor: asnavfor,
			responsive:[
		 		{
		 			breakpoint: 641, 
		 				settings: {
			        		 infinite: true,
			        		 slidesToShow: sm,
			        		 slidesToScroll: 1,
			        		 autoplay: autoplay, 
			        		 dots: showDots,
			        		 arrows: showArrows,
			        		 speed: 400,
			        		 autoplaySpeed: autoplaySpeed,
			        		 centerMode: cm,
        					 centerPadding: cm ? '25%' : '',
        					 asNavFor: asnavfor,
		 				}
		 		},
		 		{
		 			breakpoint: 1024, 
		 				settings: {
			        		infinite: true,
			        		slidesToShow: md,
			        		slidesToScroll: 1,
			        		autoplay: autoplay, 
			        		arrows: showArrows,
			        		dots: showDots,
			        		speed: 400,
			        		autoplaySpeed: autoplaySpeed,
			        		centerMode: cm,
        					centerPadding: cm ? '25%' : '',
        					asNavFor: asnavfor,
		 				}
		 		},
		 		{
		 		    breakpoint: 9999,
		 			settings: unslickonlarge ? "unslick" : {}
			 	}
		 	]
	    });
	    
        }
	}
	
	if( jQuery('.carousel .section-body').length > 0 ) {
	    jQuery('.carousel .section-body').each(function(i,v){
	        var elem = jQuery(this);
	        var slider_nav = jQuery('.slider-nav.carousel .section-body');
            var slider_for = jQuery('.slider-for.carousel .section-body');
            
	        var parent_section = elem.closest('.page-element');
	        
	        if(parent_section.hasClass('slider-nav') && slider_for.length > 0){
	            if(slider_nav.children().length == slider_for.children().length){
	                generate_carousel( elem , elem.attr('data-item-col'), '.slider-for.carousel .section-body' );
	            } else generate_carousel( elem , elem.attr('data-item-col') );
	        } else if(parent_section.hasClass('slider-for') && slider_nav.length > 0){
	            if(slider_nav.children().length == slider_for.children().length){
	                generate_carousel( elem , elem.attr('data-item-col'), '.slider-nav.carousel .section-body' );
	            } else generate_carousel( elem , elem.attr('data-item-col') );
	        } else generate_carousel( elem , elem.attr('data-item-col') );
	    
	    });
	}

	

	jQuery('.services-video-slider').slick({
		 slidesToShow: 4,
		slidesToScroll: 4,
			responsive:[
		 		{
		 			breakpoint: 641, 
		 				settings: {
			        		 infinite: true,
			        		 slidesToShow: 1,
			        		 slidesToScroll: 1,
			        		 autoplay: true, 
			        		 dots: false,
			        		 arrows: true,
			        		 speed: 400,
			        		 autoplaySpeed: 6000,
		 				}
		 		},
		 		
		 	]
	});

    //var layoutTheme = jQuery('.gallery-slide').attr('data-gallery-arrow');
    
	// jQuery('.gallery-slide').slick({
	// 	 dots: false,
	// 	 autoplay: true, 
	// 	 infinite: false,
	// 	 arrows: true,
	// 	 slidesToShow: 4,
	// 	 slidesToScroll: 4,
	// 	 speed: 400,
	// 	 autoplaySpeed: 8000,
	// 	 	responsive:[
	// 	 		{
	// 	 			breakpoint: 641, 
	// 	 				settings: {
	// 		        		 infinite: false,
	// 		        		 slidesToShow: 1,
	// 		        		 slidesToScroll: 1,
	// 		        		 autoplay: true, 
	// 		        		 dots: false,
	// 		        		 arrows: true,
	// 		        		 speed: 400,
	// 		        		 autoplaySpeed: 8000,
	// 	 				}
	// 	 		},
	// 	 		{
	// 	 			breakpoint: 1024, 
	// 	 				settings: {
	// 		        		infinite: false,
	// 		        		slidesToShow: 4,
	// 		        		slidesToScroll: 4,
	// 		        		autoplay: true, 
	// 		        		arrows: true,
	// 		        		dots: false,
	// 		        		speed: 400,
	// 		        		autoplaySpeed: 8000,
	// 	 				}
	// 	 		}
	// 	 	]
	// });
	
	//content equal height
	equalheight = function(container){

	var currentTallest = 0,
	     currentRowStart = 0,
	     rowDivs = new Array(),
	     el,
	     topPosition = 0;
	 jQuery(container).each(function() {

	   el = jQuery(this);
	   jQuery(el).height('auto')
	   topPostion = el.position().top;

	   if (currentRowStart != topPostion) {
	     for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
	       rowDivs[currentDiv].height(currentTallest);
	     }
	     rowDivs.length = 0; // empty the array
	     currentRowStart = topPostion;
	     currentTallest = el.height();
	     rowDivs.push(el);
	   } else {
	     rowDivs.push(el);
	     currentTallest = (currentTallest < el.height()) ? (el.height()) : (currentTallest);
	  }
	   for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
	     rowDivs[currentDiv].height(currentTallest);
	   }
	 });
	}

	jQuery(window).load(function() {
	  	  equalheight('.adaptive, .box-equal-height .hic-content');
	  	  equalheight('.blurb-equal-height .hic-blurb');
	  	  equalheight('.title-equal-height .hic-title');
	});


	jQuery(window).resize(function(){
	   	  equalheight('.adaptive, .box-equal-height .hic-content');
	   	  equalheight('.blurb-equal-height .hic-blurb');
	  	  equalheight('.title-equal-height .hic-title');
	});


});

jQuery(document).ready(function($) {

	var maxHeight = 0;

    $(".hic-pricing-table .hic-box").each(function(){
       if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
    });
    
    $(".hic-pricing-table .hic-box").height(maxHeight);
    
    
    var maxHeight = 0;

    $(".hic-pricing-table .hic-blurb").each(function(){
       if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
    });
    
    $(".hic-pricing-table .hic-blurb").height(maxHeight);


    var maxHeight = 0;

    $(".title-equal-height .hic-title").each(function(){
       if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
    });
    
    $(".title-equal-height .hic-title").height(maxHeight);


	$('#fullscreenMenu, .fullscreen-menu-overlay .overlay-close').on('click',function () {
		$('.fullscreen-menu-overlay').toggleClass('open');
	});

	$('#ht4-form-btn').on('click', function() {
		$('body').toggleClass('form-active');
	});

	function smooth_scroll( $element, $additionalScrollSize, $speed) {
		var positionXP = jQuery($element).position().top + jQuery(".off-canvas-wrapper").scrollTop();        
		jQuery("html, body").animate({scrollTop: positionXP - $additionalScrollSize},$speed);
	}
	
	jQuery('.button[href*="#"]').on('click', function(){
	    var btn_link = jQuery(this).attr('href');
	    var link_regx = /^((?:(https?):)?(\/{0,3})([0-9.\-A-Za-z]+)(?::(\d+))?(?:\/([^?#]*))?)?(?:\?([^#]*))?(?:#(.*))?$/;
        var match = link_regx.exec(btn_link);
        var link_anchor = "";
        
        if(typeof match[8] !== 'undefined'){
            link_anchor = '#' + match[8];
        }
        
        if(link_anchor){
            smooth_scroll(link_anchor, 0, 500);
        }
	});
	
	$(window).scroll(function() {
		if ($(this).scrollTop() > 20){  
		    $('body').addClass("scrolled");
		  }
		  else{
		    $('body').removeClass("scrolled");
		  }
		});

	 $('.speaker-button').on('click', function() {

	 		var heroVideo = $(".hero video")

	 		$('.speaker-button').toggleClass('active');


	 		if( heroVideo.prop('muted') ) {
				 heroVideo.prop('muted', false);
			 } else {
				heroVideo.prop('muted', true);
			}

	 		
	 });

	 $('.custom-category-filter li').on('click', function() {

	 	var $carCategory = $(this).attr('data-car-cat');
	 	var $details = {};

	 	$details['cat'] = $carCategory;

	 		$.ajax({
				url: obVal['adminUrl'],
				type: 'POST',
				data: {
					action: 'test_ajax_call',
					postdata: $details,
					nonce: obVal['complete_info'],
				},
				success: function( data, textStatus, xhr ) {

					var obj = $.parseJSON(data);

					

					if( obj['success'] ) {						
						$('#content_roll').html(obj.success.listing);
					} else {						
						alert('something went wrong please contact site admin');
					}

					
					
				}



			});		

	 });



	 jQuery('.team-slides').slick({
		infinite: false,
		dots: false,
		arrows: true,
		infinite: true,
		draggable: false,
		autoplay: true,
		 slidesToShow: 3,
		slidesToScroll: 3,
		autoplaySpeed: 6000,
			responsive:[
		 		{
		 			breakpoint: 641, 
		 				settings: {
			        		 infinite: true,
			        		 slidesToShow: 1,
			        		 slidesToScroll: 1,
			        		 autoplay: true, 
			        		 dots: false,
			        		 arrows: true,
			        		 speed: 400,
			        		 autoplaySpeed: 6000,
		 				}
		 		},
		 		{
		 			breakpoint: 1024, 
		 				settings: {
			        		infinite: true,
			        		slidesToShow: 2,
			        		slidesToScroll: 2,
			        		autoplay: true, 
			        		arrows: true,
			        		dots: false,
			        		speed: 400,
			        		autoplaySpeed: 6000,
		 				}
		 		}
		 	]
	});



	  // $('a[href*=#]:not([href=#])').click(function() {
   //      if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') 
   //          || location.hostname == this.hostname) {
    
   //          var target = $(this.hash);
   //          target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
   //             if (target.length) {
   //               $('html,body').animate({
   //                   scrollTop: target.offset().top
   //              }, 1000);
   //              return false;
   //          }
   //      }
   //  });




	  //  	 var items = $('#agents_list .team-list');

            
   //          $(".tabs").on("change.zf.tabs", function () {
			//     $(".home-slider-pp").slick("setPosition");
			// });
			
			
    // FAQ show / hide accordion content
	// $('.group-button > .menu [id*="faqbtn-"]').on('click', function() {
	// 	$('.group-button > .menu [id*="faqbtn-"].active').removeClass('active');
        
 //        var clickBtn = $(this);
	// 	clickBtn.addClass('active');

	// 	$('.accordion.active[id*="faq-"]').removeClass('active');

	// 	var targetElement = '.accordion' + clickBtn.attr('target');
	// 	$(targetElement).addClass('active');	
	// });

	// TABBED Content show / hide tab content
	// $('.tab-group > .menu [id*="tabbtn-"]').on('click', function() {
	// 	$('.tab-group > .menu [id*="tabbtn-"].active').removeClass('active');
        
 //        var clickTab = $(this);
	// 	clickTab.addClass('active');

	// 	$('.tab-content-wrapper .tab-content.active[id*="tab-content-"]').removeClass('active');

	// 	var targetElement = '.tab-content-wrapper .tab-content' + clickTab.attr('target');
	// 	$(targetElement).addClass('active');	
	// });

	//Disable Gravity Form field with disabled class 
	jQuery('.gfield.disabled input').attr('disabled', true);

	// Video Background positioning helper
	jQuery('.flex-video #hero_bgvid').css('top', function(){
		var top = (jQuery(this).height() - jQuery(this).closest('.video-wrap').height()) / 2 * -1; 
		return top + 'px';
	});

	jQuery('.hero .play-button').css('opacity', '1');

	jQuery('.modal-menu a').each(function(){
		var e = jQuery(this);
		var href = e.attr("href");
		var dataOpen = href ? href.replace("#","") : "modal-elem-0";
		e.attr("data-open", dataOpen);
		e.removeAttr("href");
	});
});	

//Gravity Form Custom jquery 
jQuery(document).on('gform_post_render', function(){
	// code to trigger on AJAX form render
	if(	jQuery('.registration-form').find('.ginput_preview').length > 0 ){

		next_to(3);
		prev_to(1);
		
		if(jQuery('.registration-form').find('.gform_delete').length > 0) {
			var del_btn = jQuery('.registration-form .ginput_preview .gform_delete');
			del_btn.attr('onclick', del_btn.attr('onclick') + 'next_to(2); prev_to(2)')
		}
	} else {
		jQuery('.registration-form').find('input[type="file"]').on('change', function(){
			if(	jQuery('.registration-form').find('.ginput_preview').length > 0 ){
				next_to(2);
				prev_to(2);
			} else {
				next_to(3);
				prev_to(1);
			}
		});
	}

	jQuery('.gform_wrapper').find('.gfield_select').each(function(){
		var select_field = jQuery(this);
		if(!select_field.hasClass('default-set-value') && select_field.val()=="") select_field.addClass('default-set-value');	

		if(select_field.live('change', function(){
			if(select_field.val()==""){
				if(!select_field.hasClass('default-set-value')) select_field.addClass('default-set-value');	
			} else select_field.removeClass('default-set-value');
		}));
	});

	// remove gravity form input mask underscore
	jQuery('.gfield.clear-mask').each(function(){
	    var e = jQuery(this);
	    var zipcodefield = e.hasClass('postcode');
	    var phonefield = e.hasClass('phone');
	    var form_id = e.closest('form').attr('id');
	    
	    if(form_id){
	        form_id = form_id.replace("gform_", "") ;
	        var field_id = e.attr('id');
	        
	        if(field_id){
	            field_id = field_id.replace("field_" + form_id + "_", "");
	            
	            if(zipcodefield){
        	        jQuery('#input_' + form_id + '_' + field_id).mask( '9999', { placeholder: '' } );
        	    }
        	    
        	    if(phonefield){
        	        jQuery('#input_' + form_id + '_' + field_id).mask( '9999999999', { placeholder: '' } );
        	    }
	        }
	    }
    });



});